import { useContext } from 'react';
import {
  AlisaAudioManagerStateContext,
  AlisaAudioManagerActionsContext,
} from './provider';

export const useAlisaAudioManagerState = () => {
  const context = useContext(AlisaAudioManagerStateContext);
  if (context === undefined) {
    throw new Error(
      'useAlisaAudioManagerState должен использоваться внутри AlisaAudioManagerProvider'
    );
  }
  return context;
};

export const useAlisaAudioManagerActions = () => {
  const context = useContext(AlisaAudioManagerActionsContext);
  if (context === undefined) {
    throw new Error(
      'useAlisaAudioManagerActions должен использоваться внутри AlisaAudioManagerProvider'
    );
  }
  return context;
};
